import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaCcApplePay, FaAngleRight } from "react-icons/fa";
import { BiConversation } from "react-icons/bi";
import { IoPeople } from "react-icons/io5";
import "./DMCA.scss";

const Bottom = () => {
  return (
    <div id="dmca">
      {/* link component */}
      <div className="box">
        <Container className="support-link px-4 py-md-5 py-3  ">
          <Row className=" justify-content-around">
            <Col md={3}>
              <div className="content">
                <BiConversation className="icon" />
                <h4>Apple communities</h4>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <Link>
                  Ask or search now <FaAngleRight />
                </Link>
              </div>
            </Col>
            <Col md={3}>
              <div className="content">
                <IoPeople className="icon" />
                <h4>Get support</h4>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <Link>
                  Start now <FaAngleRight />
                </Link>
              </div>
            </Col>
            <Col md={3}>
              <div className=" content">
                <FaCcApplePay className="icon" />
                <h4>Support app</h4>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <Link>
                  Download the apple Support App <FaAngleRight />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>{" "}
    </div>
  );
};
export default Bottom;
